import { RenderableBase } from './renderable-base';

export class RenderableGroup extends RenderableBase<void> {
  public override layout = 'page';
  public override subrenderables: Array<RenderableBase<any>> = [];
}
